module.exports = __webpack_public_path__ + "static/media/atom-dark.4dc153fb.png";